<modal-pds3 [isOpen]="true" (userRequest)="handleUserRequest()" srLabelledBy="wk-modal__header-title">
    <div tabindex="-1">
        <vertical-layout-pds3 flowClass="wk-modal-container">
            <vertical-layout-header-pds3 flowClass="wk-modal__header">
                <h1 id="wk-modal__header-title" class="wk-modal__header-title">{{ title() | translate }}</h1>
                <div class="wk-modal__header-actions">
                    <button-field-pds3 type="icon" size="large" class="wk-modal__header-close">
                        <button (click)="close()" type="button">
                            <icon-pds3 name="wk-icon-close" />
                            <sr-only-pds3>{{ "General.CloseModal" | translate }}</sr-only-pds3>
                        </button>
                    </button-field-pds3>
                </div>
            </vertical-layout-header-pds3>
            <vertical-layout-content-pds3 flowClass="wk-modal-content">
                @if (description()) {
                    <p>{{ description() }}</p>
                }
                <ng-content />
            </vertical-layout-content-pds3>
            <vertical-layout-footer-pds3 flowClass="wk-modal__footer">
                <div class="wk-modal__footer__actions">
                    <button-field-pds3
                        type="primary"
                        [class]="`wk-modal__footer__action-submit wk-modal__footer__action--${confirmAction().type}`"
                        size="large"
                        [color]="confirmAction().type"
                    >
                        <button type="submit" (click)="submit()" [disabled]="isUpdating() || confirmDisabled()">
                            @if (confirmAction().icon) {
                                <icon-pds3 [name]="confirmAction().icon" />
                            }
                            @if (isUpdating()) {
                                <app-loader [isOverlay]="false" size="button" />
                            }
                            {{ confirmAction().title | translate }}
                        </button>
                    </button-field-pds3>
                    <button-field-pds3 type="text" class="wk-modal__footer__action-cancel" size="large">
                        <button type="button" [disabled]="isUpdating()" (click)="close()">{{ "General.Cancel" | translate }}</button>
                    </button-field-pds3>
                </div>
            </vertical-layout-footer-pds3>
        </vertical-layout-pds3>
    </div>
</modal-pds3>
